import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import CoursesEvents from './CoursesEvents';

import CoursesDetailsSectionSecondaryInfo from './details/sections/CoursesDetailsSectionSecondaryInfo';
import CoursesDetailsSectionInfo from './details/sections/CoursesDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<CoursesDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="crss_descriptionhtml"
				value={props.model.crss_descriptionhtml}
				sendChange={props.sendChange}
				isEdit={props.isEdit}
			/>
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<CoursesDetailsSectionSecondaryInfo {...props} />
		</>
	),
	events: CoursesEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
